module.exports = __webpack_public_path__ + "img/logo-uib.4467e84e.svg";